var render = function render(){var _vm=this,_c=_vm._self._c;return _c('as-modal',{attrs:{"title":"No Credit Impact"},on:{"close":function($event){return _vm.$emit('close', $event)}}},[_c('p',[_vm._v("Providing your online banking details to AccountScore will not leave a footprint on your credit report.")]),_c('p',[_vm._v(_vm._s(_vm.client)+" may have obtained a credit report to evaluate your application.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }